<div class="header" id="treatment-chart-heading">
  <h3>STATUS BY TREATMENT TYPE</h3>
</div>
<div class="status-data">
  <div class="chart">
    @if (summaryInfoRegion() || summaryInfoForest()) {
      <ng-charts-bar-horizontal-stacked [results]="treatmentData" [scheme]="colorScheme" [gradient]="false"
        [xAxis]="true" [yAxis]="true" [legend]="true" [showXAxisLabel]="true" [showYAxisLabel]="true" [trimYAxisTicks] = 'false'
        [xAxisLabel]="'Authorized Funding by Treatment'" [yAxisLabel]="yLabel" [legendTitle]="'Treatment Types'"
        [legendPosition]="legendPosition" [showDataLabel]="true" [noBarWhenZero]="false" [wrapTicks]="true">
      </ng-charts-bar-horizontal-stacked>
    }
    @if (!summaryInfoRegion() && !summaryInfoForest()) {
      <ng-charts-bar-horizontal [results]="treatmentData" [scheme]="colorScheme" [gradient]="false"
        [xAxis]="true" [yAxis]="true" [legend]="true" [showXAxisLabel]="true" [showYAxisLabel]="true" [trimYAxisTicks] = 'false'
        [xAxisLabel]="'Authorized Funding by Treatment'" [yAxisLabel]="yLabel" [legendTitle]="'Treatment Types'"
        [legendPosition]="legendPosition" [showDataLabel]="true" [noBarWhenZero]="false" [wrapTicks]="true">
      </ng-charts-bar-horizontal>
    }
  </div>
  <div class="grid">
    @if (summaryInfoRegion() || summaryInfoForest()) {
      <table mat-table [dataSource]="summaryData" class="center"
        matSortDisableClear
        multiTemplateDataRows
        aria-labelledby="treatment-chart-heading treatment-chart-caption"
        >
        <caption id="treatment-chart-caption" class="usa-sr-only">
          Status By Treatment Type. Columns: Region, Authorized Funding, Requested Funding,
          BAER Wildfires, NFS Acres.
        </caption>
        <ng-container matColumnDef="region">
          <th mat-header-cell *matHeaderCellDef>Region</th>
          <td mat-cell *matCellDef="let data">{{data.region}}</td>
          <td mat-footer-cell *matFooterCellDef class="green">Total</td>
        </ng-container>
        <ng-container matColumnDef="forest">
          <th mat-header-cell *matHeaderCellDef>Forest</th>
          <td mat-cell *matCellDef="let data">{{data.forest_name}}</td>
          <td mat-footer-cell *matFooterCellDef class="green">Total</td>
        </ng-container>
        <ng-container matColumnDef="authorized_funding">
          <th mat-header-cell *matHeaderCellDef class="align-right">Authorized Funding</th>
          <td mat-cell *matCellDef="let data" class="align-right">{{'$'+(data.total_auth ?? 0 | number:'1.2-2') | empty_check}}</td>
          <td mat-footer-cell *matFooterCellDef class="align-right green">{{'$'+(totalAuth | number:'1.2-2') | empty_check}}</td>
        </ng-container>
        <ng-container matColumnDef="requested_funding">
          <th mat-header-cell *matHeaderCellDef class="align-right">Requested Funding</th>
          <td mat-cell *matCellDef="let data" class="align-right">{{'$'+(data.total_req ?? 0 | number:'1.2-2') | empty_check}}</td>
          <td mat-footer-cell *matFooterCellDef class="align-right green">{{'$'+(totalReq | number:'1.2-2') | empty_check}}</td>
        </ng-container>
        <ng-container matColumnDef="fires">
          <th mat-header-cell *matHeaderCellDef>BAER Wildfires</th>
          <td mat-cell *matCellDef="let data">{{(data.fire_count ?? 0) | number:'1.0-2'}}</td>
          <td mat-footer-cell *matFooterCellDef class="green">{{(totalFires) | number:'1.0-2'}}</td>
        </ng-container>
        <ng-container matColumnDef="nfs_acres">
          <th mat-header-cell *matHeaderCellDef>NFS Acres</th>
          <td mat-cell *matCellDef="let data">{{(data.nfs_acres ?? 0) | number:'1.0-2'}}</td>
          <td mat-footer-cell *matFooterCellDef class="green">{{(totalAcres) | number:'1.0-2'}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    }
    @if (!summaryInfoRegion() && !summaryInfoForest()) {
      <table mat-table [dataSource]="summaryData" class="center" matSortDisableClear multiTemplateDataRows>
        <ng-container matColumnDef="treatment">
          <th mat-header-cell *matHeaderCellDef>Treatment Type</th>
          <td mat-cell *matCellDef="let data">{{data.treatment}}</td>
          <td mat-footer-cell *matFooterCellDef class="green">Total</td>
        </ng-container>
        <ng-container matColumnDef="authorized_funding">
          <th mat-header-cell *matHeaderCellDef class="align-right">Authorized Funding</th>
          <td mat-cell *matCellDef="let data" class="align-right">{{'$'+(data.authorized ?? 0 | number:'1.2-2') | empty_check}}</td>
          <td mat-footer-cell *matFooterCellDef class="align-right green">{{'$'+(summaryInfoSelected().total_auth | number:'1.2-2') | empty_check}}</td>
        </ng-container>
        <ng-container matColumnDef="requested_funding">
          <th mat-header-cell *matHeaderCellDef class="align-right">Requested Funding</th>
          <td mat-cell *matCellDef="let data" class="align-right">{{'$'+(data.requested ?? 0 | number:'1.2-2') | empty_check}}</td>
          <td mat-footer-cell *matFooterCellDef class="align-right green">{{'$'+(summaryInfoSelected().total_req | number:'1.2-2') | empty_check}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns_forest"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns_forest;" class="example-element-row"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns_forest"></tr>
      </table>
    }
  </div>
</div>
